import React from 'react';
import { motion } from 'framer-motion';
import { Gift, ArrowRight, Clock } from 'lucide-react';
export function MagazinConsultation() {
  return <section className="pb-24 lg:pb-32 bg-brand-cream" data-id="element-1565">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1566">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="relative bg-gradient-to-br from-brand-text via-brand-purple to-[#4F2E7E] rounded-[2.5rem] p-8 md:p-12 lg:p-16 overflow-hidden shadow-2xl" data-id="element-1567">
          {/* Decorative blobs */}
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-gold/15 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1568" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-gold/10 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1569" />

          <div className="relative flex flex-col items-center text-center gap-6" data-id="element-1570">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-brand-gold/20 backdrop-blur-sm flex items-center justify-center text-brand-gold border border-brand-gold/30" data-id="element-1571">
              <Gift className="w-10 h-10 md:w-12 md:h-12" data-id="element-1572" />
            </div>

            <div className="flex flex-col items-center" data-id="element-1573">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/20 text-brand-gold text-xs font-bold uppercase tracking-wider mb-4" data-id="element-1574">
                <Clock className="w-3.5 h-3.5" data-id="element-1575" />
                20 de minute · cadou
              </div>
              <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4 text-balance" data-id="element-1576">
                Nu știi ce să alegi?
              </h2>
              <p className="text-white/80 text-lg leading-relaxed max-w-2xl" data-id="element-1577">
                Rezervă o sesiune de consultanță cadou de 20 de minute cu
                Adrian. Vorbim despre unde te afli acum, ce îți dorești și ce
                curs sau program ți se potrivește cel mai bine.
              </p>
            </div>

            <a href="https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc." target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-text font-heading font-bold text-lg px-8 py-4 rounded-full hover:bg-white transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 whitespace-nowrap" data-id="element-1578">
              Rezervă Sesiunea
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1579" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}